/* ============================================================
   NFC Review Cards - scripts propios (sin librerias externas)
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Solo escondemos los elementos si este script se esta ejecutando de verdad:
  // si fallara, la pagina se ve entera en vez de quedarse en blanco.
  document.documentElement.classList.add('nfc-anim');

  /* ---------- Animaciones de entrada ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.nfc-reveal:not(.nfc-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('nfc-visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-nfc-delay') || '0', 10);
        setTimeout(function () { el.classList.add('nfc-visible'); }, delay);
        observer.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    for (var j = 0; j < items.length; j++) observer.observe(items[j]);

    // Red de seguridad: si el navegador no llega a avisarnos (pestana congelada,
    // motor sin pintar, etc.) mostramos el contenido igualmente a los 3,5 s.
    setTimeout(function () {
      var pendientes = document.querySelectorAll('.nfc-reveal:not(.nfc-visible)');
      for (var k = 0; k < pendientes.length; k++) pendientes[k].classList.add('nfc-visible');
    }, 3500);
  }

  /* ---------- Galeria de la pagina de producto ---------- */
  function initGallery() {
    var galleries = document.querySelectorAll('[data-nfc-gallery]');
    if (!galleries.length) return;

    Array.prototype.forEach.call(galleries, function (gallery) {
      var slides = gallery.querySelectorAll('[data-nfc-slide]');
      var thumbs = gallery.querySelectorAll('[data-nfc-thumb]');
      if (!slides.length || !thumbs.length) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          var index = thumb.getAttribute('data-nfc-thumb');

          Array.prototype.forEach.call(slides, function (slide) {
            var active = slide.getAttribute('data-nfc-slide') === index;
            slide.classList.toggle('is-active', active);
            var video = slide.querySelector('video');
            if (video && !active && typeof video.pause === 'function') video.pause();
          });

          Array.prototype.forEach.call(thumbs, function (other) {
            other.classList.toggle('is-active', other === thumb);
          });
        });
      });
    });
  }

  /* ---------- Selector de variantes ---------- */
  function initVariants() {
    var blocks = document.querySelectorAll('[data-nfc-variants]');
    if (!blocks.length) return;

    Array.prototype.forEach.call(blocks, function (block) {
      var inputs = block.querySelectorAll('[data-nfc-variant]');
      if (!inputs.length) return;

      var idField = block.querySelector('[data-nfc-variant-id]');
      var priceEl = block.querySelector('[data-nfc-price]');
      var compareEl = block.querySelector('[data-nfc-compare]');
      var unitEl = block.querySelector('[data-nfc-unit]');
      var stockEl = block.querySelector('[data-nfc-stock]');
      var button = block.querySelector('[data-nfc-add]');
      var soldOutText = block.getAttribute('data-sold-out') || 'Sold out';
      var addText = button ? button.getAttribute('data-default-text') || button.textContent.trim() : '';

      function apply(input) {
        if (idField) idField.value = input.value;

        var price = input.getAttribute('data-price') || '';
        var compare = input.getAttribute('data-compare') || '';
        var unit = input.getAttribute('data-unit') || '';
        var available = input.getAttribute('data-available') === 'true';

        if (priceEl) priceEl.textContent = price;
        if (compareEl) {
          compareEl.textContent = compare;
          compareEl.hidden = compare === '';
        }
        if (unitEl) unitEl.textContent = unit;

        if (stockEl) {
          stockEl.classList.toggle('is-out', !available);
          stockEl.querySelector('[data-nfc-stock-text]').textContent =
            available ? (stockEl.getAttribute('data-in-text') || 'In stock') : (stockEl.getAttribute('data-out-text') || 'Out of stock');
        }

        if (button) {
          button.disabled = !available;
          button.textContent = available ? addText : soldOutText;
        }

        Array.prototype.forEach.call(inputs, function (other) {
          var label = other.closest('.nfc-pdp__opt');
          if (label) label.classList.toggle('is-active', other === input);
        });
      }

      Array.prototype.forEach.call(inputs, function (input) {
        input.addEventListener('change', function () { if (input.checked) apply(input); });
      });

      var checked = block.querySelector('[data-nfc-variant]:checked');
      if (checked) apply(checked);
    });
  }


  /* ---------- Numeros que cuentan hacia arriba ---------- */
  function initContadores() {
    var nums = document.querySelectorAll('[data-nfc-contador]:not([data-nfc-hecho])');
    if (!nums.length) return;

    function animar(el) {
      el.setAttribute('data-nfc-hecho', '1');
      var destino = parseInt(el.getAttribute('data-nfc-contador'), 10) || 0;
      if (reduceMotion) { el.textContent = destino.toLocaleString(); return; }
      var inicio = null;
      var duracion = 1400;
      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min((t - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(destino * suave).toLocaleString();
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nums, animar);
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        animar(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.4 });

    Array.prototype.forEach.call(nums, function (n) { obs.observe(n); });

    setTimeout(function () {
      var faltan = document.querySelectorAll('[data-nfc-contador]:not([data-nfc-hecho])');
      for (var k = 0; k < faltan.length; k++) {
        faltan[k].setAttribute('data-nfc-hecho', '1');
        faltan[k].textContent = (parseInt(faltan[k].getAttribute('data-nfc-contador'), 10) || 0).toLocaleString();
      }
    }, 6000);
  }

  function init() {
    initReveal();
    initContadores();
    initGallery();
    initVariants();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializamos.
  document.addEventListener('shopify:section:load', init);

  // Las pestanas en segundo plano congelan las animaciones: al volver, reintentamos.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) { initReveal(); initContadores(); }
  });
})();
